import {Component, OnInit} from '@angular/core';
import {PlatformProfile} from "../../../model/platformprofile";
import {SavedProperty} from "../../../model/savedProperty";
import {debounceTime, startWith} from "rxjs/operators";
import {debounce} from "lodash";
import {Subject, Subscription} from "rxjs";
import {LoginIdService} from "../../../service/login-id.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-saved-properties',
  templateUrl: './saved-properties.component.html',
  styleUrls: ['./saved-properties.component.css']
})
export class SavedPropertiesComponent implements OnInit {

  platformProfile: PlatformProfile;
  savedProperties: Array<SavedProperty> = new Array<SavedProperty>();
  searchText: string = "";
  searchTextSubject = new Subject<string>();
  companyLoginSubscription: Subscription;
  foundObjects:boolean = true;
  loadingSavedProperties: boolean = false;
  selectedMandateId: string = "init";

  selectedTab: string = "Portfolioverwaltung"

  protected readonly debounce = debounce;
  constructor(private loginIdService: LoginIdService, private router: Router) { }

  async ngOnInit(): Promise<void> {
      await this.loginIdService.loginServiceInitialized$.toPromise();

      this.companyLoginSubscription = this.loginIdService.loginIdChanged$.pipe(startWith(true)).subscribe(() => {
          this.handleLoginIdChange()
      })

      this.loginIdService.loadingSavedPropertiesChanged$.subscribe(isLoading => {
          if(!isLoading){
              this.initPlatformProfile()
          }
          this.loadingSavedProperties = isLoading;
      })

      this.searchTextSubject.pipe(debounceTime(300)).subscribe(() => {
          this.filterPlatformSavedProperties();
      })
  }

    /**
     * Handles what should happen after the platform profile in the session storage was updated (after the login id changed)
     * If the new platform is a connect platform and the multi user is an admin the saved properties are being updated
     * else the user is being navigated to the dashboard.
     */
  private handleLoginIdChange(): void{
      this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));
      if (this.platformProfile && (this.platformProfile.platformType === "CONNECT" || this.platformProfile.platformType === "MANDATE") && this.loginIdService.isAdmin()) {
          this.savedProperties = this.platformProfile.properties;
      }
      else{
          this.router.navigate(['/home']);
      }
  }

  setFoundObjects(){
    let numberOfFoundObjects = document.querySelectorAll('#object').length;
    this.foundObjects = numberOfFoundObjects > 0;
  }

  hasPropertyRightMandate(savedProperty: SavedProperty){
    if(this.platformProfile){
      return this.platformProfile.mandate.find(m => m.id = savedProperty.mandateId);
    }
    return false;
  }

    /**
     * Select the new tab
     *
     * @param tab name of the tab that should be selected
     */
  public selectTab(tab: string): void{
      this.selectedTab = tab;
  }

    /**
     * Sets the searchText for a Subject.
     * Used to add a debounce time after the user inputs a search text.
     */
  public onSearchInputChange(): void{
      this.searchTextSubject.next(this.searchText);
  }

    /**
     * Filters the saved properties of this.platformProfile based on searchText
     */
  public filterPlatformSavedProperties(): void{
      this.platformProfile.properties = this.savedProperties;
      if(this.searchText){
          this.platformProfile.properties = this.platformProfile.properties.filter(savedProperty => {
              return this.matchesSearchCriteria(savedProperty);
          })
      }
  }

    /**
     * Checks if the search text is included in the single properties of a saved property
     *
     * @param savedProperty SavedProperty which should be checked
     * @return True if any property of the saved property includes the search text else false
     */
  public matchesSearchCriteria(savedProperty: SavedProperty): boolean{
      const search = this.searchText.toLowerCase();
      return(
              savedProperty.id.toLowerCase().includes(search) ||
              savedProperty.name.toLowerCase().includes(search) ||
              savedProperty.street.toLowerCase().includes(search) ||
              savedProperty.zip.toLowerCase().includes(search) ||
              savedProperty.town.toLowerCase().includes(search)
      );
  }

  /**
   * Initializes the platform profile from the session storage
   */
  private initPlatformProfile(): void {
      this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));
      if (this.platformProfile) {
          this.savedProperties = this.platformProfile.properties;
      }
  }
}
